import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, Checkbox, CardHeader, CardContent, Stack, Typography } from '@mui/material';

import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';

export const GuardiansForm = props => {
  const { seasonIdentifier } = useSelector(state => state.app);
  const { formik } = props;

  return (
    <Card>
      <CardHeader title="Dane opiekunów" sx={{ mt: -1 }} />
      <CardContent>
        <Box display="flex" flexDirection="row" justifyContent="center" m={2} p={1} flexWrap="wrap">
          <Stack direction="column">
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba opiekunów (mężczyzn) gratis</Typography>
              <SmallFormTextField
                error={formik.errors.free_guardian_man_count && formik.touched.free_guardian_man_count}
                name="free_guardian_man_count"
                placeholder="liczba darmowych opiekunów"
                value={formik.values.free_guardian_man_count}
                onChange={formik.handleChange}
                helperText={formik.errors.free_guardian_man_count}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba opiekunów (kobiet) gratis</Typography>
              <SmallFormTextField
                error={formik.errors.free_guardian_woman_count && formik.touched.free_guardian_woman_count}
                name="free_guardian_woman_count"
                placeholder="liczba darmowych opiekunek"
                value={formik.values.free_guardian_woman_count}
                onChange={formik.handleChange}
                helperText={formik.errors.free_guardian_woman_count}
              />
            </Stack>
            { ['l_24_zs', 'l_25_zs'].includes(seasonIdentifier) ? null : <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
              <Typography variant="subtitle2">Czy kierowca pozostaje w ośrodku</Typography>
              <Checkbox
                id="driver_on_resort"
                name="driver_on_resort"
                checked={formik.values.driver_on_resort}
                onChange={formik.handleChange}/>
            </Stack>}
          </Stack>
          <Stack direction="column">
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba opiekunów (mężczyzn) płatnych</Typography>
              <SmallFormTextField
                error={formik.errors.paid_guardian_man_count && formik.touched.paid_guardian_man_count}
                name="paid_guardian_man_count"
                placeholder="liczba płatnych opiekunów"
                value={formik.values.paid_guardian_man_count}
                onChange={formik.handleChange}
                helperText={formik.errors.paid_guardian_man_count}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba opiekunów (kobiet) płatnych</Typography>
              <SmallFormTextField
                error={formik.errors.paid_guardian_woman_count && formik.touched.paid_guardian_woman_count}
                name="paid_guardian_woman_count"
                placeholder="liczba płatnych opiekunek"
                value={formik.values.paid_guardian_woman_count}
                onChange={formik.handleChange}
                helperText={formik.errors.paid_guardian_woman_count}
              />
            </Stack>
            {['l_25', 'l_26', 'l_27', 'l_25_wr', 'l_26_wr', 'l_27_wr', 'l_26_zs', 'l_27_zs'].includes(seasonIdentifier) ? null : <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} p={2}>
              <Typography variant="subtitle2">Liczba kierowców</Typography>
              <SmallFormTextField
                error={formik.errors.drivers_count && formik.touched.drivers_count}
                name="drivers_count"
                placeholder="liczba kierowców"
                value={formik.values.drivers_count}
                onChange={formik.handleChange}
                helperText={formik.errors.drivers_count}
              />
            </Stack>}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};
